import axios from '../index';
import axiosInstance from '../index';

export const GetSettingData = async () => {
  let result = {};
  try {
    const res = await axios.get(`api/elastic/settings_config`);
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const GetPersonalData = async (id) => {
  let result = {};
  try {
    const res = await axios.get(`api/account/usermanage/${id}/`);
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};
export const UpdatePersonalData = async (params) => {
  let result = {};
  const { id, first_name, last_name, email, phone_number, profile_picture } = params;
  const data = { first_name, last_name, email, phone_number, profile_picture };
  try {
    const res = await axios.patch(`api/account/usermanage/${id}/`, { data });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const postLOB = async (lobData) => {
  let result = {};
  try {
    const res = await axiosInstance.post(`api/managelob/`, lobData, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const putLOB = async (lobData, id) => {
  let result = {};
  try {
    const res = await axiosInstance.put(`api/managelob/${id}/`, lobData, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const deleteLOB = async (id) => {
  let result = {};
  try {
    const res = await axiosInstance.delete(`api/managelob/${id}/`, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const getTeamLead = async () => {
  let result = {};
  try {
    const res = await axiosInstance.get(`api/manageteamlead/`, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const getSopTypes = async () => {
  let result = {};
  try {
    const res = await axiosInstance.get(`api/managesoptypes/`, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const postTeam = async (teamData) => {
  let result = {};
  try {
    const res = await axiosInstance.post(`api/manageteam/`, teamData, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const putTeam = async (teamData, id) => {
  let result = {};
  try {
    const res = await axiosInstance.put(`api/manageteam/${id}/`, teamData, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const deleteTeam = async (id) => {
  let result = {};
  try {
    const res = await axiosInstance.delete(`api/manageteam/${id}/`, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const getLOB = async () => {
  return axios.get(`api/managelob/`, { withCredentials: true });
};

export const getAgentList = () => {
  return axios.get(`api/manageagent/`, { withCredentials: true });
};

export const getTeam = async () => {
  return axios.get(`api/manageteam/`, { withCredentials: true });
};

export const postAgent = async (agentData) => {
  let result = {};
  try {
    const res = await axiosInstance.post(`api/manageagent/`, agentData, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const putAgent = async (agentData, id) => {
  let result = {};
  try {
    const res = await axiosInstance.put(`api/manageagent/${id}/`, agentData, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const deleteAgent = async (id) => {
  let result = {};
  try {
    const res = await axiosInstance.delete(`api/manageagent/${id}/`, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const getAccountDetails = async () => {
  let result = {};
  try {
    const res = await axiosInstance.get(`api/manageuser`, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const getHelpCenterDetails = async () => {
  let result = {};
  try {
    const res = await axiosInstance.get(`api/managehelp/`, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};
export const updateHelpCenterDetails = async (bodyFormData, id) => {
  let result = {};
  try {
    const res = await axiosInstance.put(`api/managehelp/${id}/`, bodyFormData, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const gettabledata = async () => {
  let result = {};
  try {
    const res = await axiosInstance.get(`api/managesettingreporting/`, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const updatecustomertabledata = async (updatedlists) => {
  let result = {};
  try {
    const res = await axiosInstance.post(
      `api/managesettingcustomerreporting/`,
      { data: { weightage: updatedlists } },
      { withCredentials: true }
    );
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const getBillingAmount = async (timeperiod) => {
  let result = {};
  try {
    const res = await axiosInstance.post(`elastic/billing/`, timeperiod, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const getInvoice = async () => {
  let result = {};
  try {
    const res = await axiosInstance.get(`api/manageinvoice/`, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};

export const getInvoiceByRecord = async (id) => {
  let result = {};
  try {
    const res = await axiosInstance.get(`api/invoice/${id}`, { withCredentials: true });
    result = res.data || {};
    return { success: true, data: result };
  } catch (err) {
    return {
      success: false,
      message: err || 'something went wrong'
    };
  }
};
